import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6915f28f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6915f28f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6915f28f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\project\\bigBee\\bigbee_backend_ui_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6915f28f')) {
      api.createRecord('6915f28f', component.options)
    } else {
      api.reload('6915f28f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6915f28f&scoped=true", function () {
      api.rerender('6915f28f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screen/components/ScreenCard/index.vue"
export default component.exports